import axios from 'axios';
import qs from 'qs';
import config from '@/config/config';
import router from '../router'
import Vue from 'vue';
import { Toast, Loading } from 'vant';
import wx from 'weixin-js-sdk'
import cookies from 'vue-cookies'


Vue.use(Toast).use(Loading);
/*
  * Request(): 请求后台数据，返回成功后，执行callback
  * url: 请求的半路径
  * params: { data：请求参数，methods：请求方式，callback：回调方法 }
*/
export const Request = (url = '', params = {}) => {
    // let token = cookies.get('token');
    // let token='a091c1d9-d873-4651-a6c5-f268d6f3ada2'
    // 获取请求公用参数
    // params.data.token = token;
    params.data.clt = 'h5';

    params.data.token = cookies.get("hbscToken") || sessionStorage.getItem('hbscToken')
    params.data.memberId = cookies.get("memberId") || sessionStorage.getItem('memberId')
    params.data.memberName = cookies.get("memberName") || sessionStorage.getItem('memberName')
    params.data.memberPhone = cookies.get("memberPhone") || sessionStorage.getItem('memberPhone')

    // 不同的后台接口传不同的请求方式 以及和传参格式  将token设置在请求头中
    let contentType = 'application/x-www-form-urlencoded';
    let requestData = qs.stringify(params.data);
    if (params.type == 'json') {
        contentType = 'application/json';
        requestData = JSON.stringify(params.data);
    } else if (params.type == 'file') {
        contentType = "multipart/form-data; boundary = " + new Date().getTime()
        requestData = params.data
    }
    if (params.methods == 'GET') {
        //如果不存在数据 则返回假数据
        return new Promise((resolve) => {
            //加载提示
            Toast.loading({
                message: '加载中...',
                loadingType: 'spinner',
                forbidClick: true,
                duration: '10000'
            });
            axios.get(config.domainPath + url, {
                params: Object.assign(params.data, {})
            }).then((res) => {
                if (res.data.code == "4000") {
                    Toast('登录失败，请重新登录');
                    // this.$cookies.remove('token');
                    // setTimeout(function () {
                    //     // router.push({ path: "/login" });
                    //     wx.miniProgram.navigateTo({
                    //         url: '/pages/login/login'
                    //     })
                    // }, 1000);
                }
                Toast.clear();
                return resolve(res.data);
            }).catch(err => {
                Toast.clear();
                console.log(err);
                return false;
            });
        });
    } else {
        return new Promise((resolve) => {
            // 加载提示
            // Toast.loading({
            //     message: '加载中...',
            //     loadingType: 'spinner',
            //     forbidClick: true,
            //     duration: '10000'
            // });
            axios({
                url: config.domainPath + url,
                method: 'post',
                data: requestData,
                headers: {
                    'Content-Type': contentType,
                }
            }).then(res => {
                if (res.data.code == "4000") {
                    Toast(res.data.msg || '登录失败');
                    this.$cookies.remove('token');
                    setTimeout(function () {
                        // router.push({ path: "/login" });
                        wx.miniProgram.navigateTo({
                            url: '/pages/login/login'
                        })
                    }, 1000);
                }
                if (res.data.code == "0000") {
                    Toast.clear();
                    return resolve(res.data);
                } else {
                    Toast(res.data.msg||res.data.error);
                    return resolve(res.data);
                }
            }).catch(err => {
                Toast.clear();
                console.log(err);
                return false;
            })
        });
    }
};
